import { ConditionType } from "src/types/visual";

export const colors = {
  base: {
    [ConditionType.And]: "teal.300",
    [ConditionType.Or]: "warning.300",
  },
  hover: {
    [ConditionType.And]: "teal.400",
    [ConditionType.Or]: "warning.400",
  },
  text: {
    [ConditionType.And]: "teal.800",
    [ConditionType.Or]: "warning.800",
  },
  textHover: {
    [ConditionType.And]: "teal.900",
    [ConditionType.Or]: "warning.900",
  },
};
